import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { AreaNotesState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: AreaNotesState = getDefaultState();

export const areaNotes: Module<AreaNotesState, RootState> = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
